module.exports = __webpack_public_path__ + "img/info-item-2.71eec2fc.png";